// sessionStorage

export const loadSessionState = () => {
  try {
    const serializedState = sessionStorage.getItem('ips_cart_store'); // Verwendung von sessionStorage
    if (serializedState === null) {
      return undefined;
    }
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

export const saveSessionState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    sessionStorage.setItem('ips_cart_store', serializedState); // Verwendung von sessionStorage
  } catch (err) {
    console.error("Can't save changes in session storage", err);
  }
};

export const clearSessionState = () => {
  try {
    sessionStorage.removeItem('ips_cart_store'); // Sitzungsspeicher löschen
  } catch (err) {
    console.error("Can't clear session storage", err);
  }
};